import { proxy, useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";

export function createProgressBar(segments: string[], titles: Record<string, string>) {
  return proxy({
    activeSegmentIndex: 0,
    segments,
    titles,
  });
}

type ProgressBarConfig = {
  segments: string[];
  titles: Record<string, string>;
  activeSegmentIndex: number;
};

export function useProgressBar(progressBarConfig: ProgressBarConfig) {
  const { segments, activeSegmentIndex, titles } = useSnapshot(progressBarConfig);
  const { t } = useTranslation();

  function activateProgressBarSegment(segment: string) {
    progressBarConfig.activeSegmentIndex = progressBarConfig.segments.indexOf(segment);
  }

  function segmentState(segment: string) {
    if (segments.indexOf(segment) < activeSegmentIndex) {
      return "finished";
    }

    if (segments.indexOf(segment) === activeSegmentIndex) {
      return "active";
    }

    return "inactive";
  }

  function segmentTitle(segment: string) {
    return t(titles[segment]);
  }

  return {
    activeSegmentIndex,
    segments,
    activateProgressBarSegment,
    segmentState,
    segmentTitle,
  };
}
